import styles from './PaginationButton.module.scss';
type PaginationButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  variant?: 'prev' | 'next';
};
export const PaginationButton = ({
  onClick,
  disabled,
  variant = 'next',
}: PaginationButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={[styles.button, styles[`--${variant}`]].join(' ')}
    />
  );
};
